import clsx from 'clsx';
import React, { useState } from 'react';

import type { PlaygroundLog } from '@/types/logs';

import styles from './renderLogList.module.scss';

type Props = {
  logs: PlaygroundLog[];
  onLogClick: ( index: number ) => void;
};

const LOG_TYPE_LABELS: Record<PlaygroundLog['_logType'], string> = {
  action: 'Action Log',
  model: 'Model Log',
  request: 'Request Log'
};

const RenderLogList = ( { logs, onLogClick }: Props ) => {
  const [ activeIndex, setActiveIndex ] = useState<number | null>( null );

  const handleClick = ( index: number ) => {
    setActiveIndex( index );
    onLogClick( index );
  };

  return (
    <>
      <div className={ styles.loglist } >
        <div className={ styles.header }>
          <label>Logs</label>
        </div>

        {logs.map( ( item, index ) => (
          <div
            key={ `${ index }` }
            onClick={ () => handleClick( index ) }
            className={ clsx(
              styles.logitem,
              activeIndex === index && styles.active
            ) }
          >
            <span>{ LOG_TYPE_LABELS[item._logType] }</span>
            <span>id: {item.id}</span>
            <span>time: {item.start_time}</span>
            {item._logType === 'request' && item.method && item.path && (
              <span>{item.method} {item.path}</span>
            )}
            {item._logType === 'request' && item.status_code !== undefined && (
              <span>status: {item.status_code}</span>
            )}
          </div>
        ) )}
      </div>
    </>
  );
};

export default RenderLogList;
